import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GetRDSDevicesStatusQuery, RDSDevicesSortInput, RDSDevicesStatusFilter, RDSPaginationInput } from 'ngx-core-services';

const getDevicesFragment = `
  fragment rdsdevicesstatustype on RDSDevicesStatusType {
    devices {
      deviceId
      devType
      batteryModel
      arm
      dspm
      dsps
      isInAlarm
      hasAzzurroEvents
      updatedAt
      createdAt
    }
    totalCount
  }
`;

@Injectable()
export class DeviceRegistryService {

  constructor(private readonly getRDSDevicesStatusQuery: GetRDSDevicesStatusQuery) { }

  async getDevices(
    pagination: RDSPaginationInput,
    filter?: RDSDevicesStatusFilter,
    sort?: RDSDevicesSortInput
  ) {
    const query = gql`${getDevicesFragment}`;
    const { data } = await this.getRDSDevicesStatusQuery.execute(
      query,
      {
        input: {
          pagination,
          filter,
          sort,
        },
      },
      true,
    );

    return data?.getRDSDevicesStatus;
  }
}